import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03952c05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "font-app w-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_3 = {
  key: 1,
  class: "h-full"
}
const _hoisted_4 = { class: "h-full" }
const _hoisted_5 = { class: "flex items-center justify-center w-full h-auto min-h-screen" }
const _hoisted_6 = { class: "font-bold fixed right-10 bottom-10 text-2xl text-right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { ExclamationCircleIcon } from '@heroicons/vue/24/solid';
import FirstStep from './FirstStep.vue';
import QuestionsCover from './QuestionsCover.vue';
import Question from './Question.vue';
import UserInputQuestion from './UserInputQuestion.vue';
import IncompatibleScreen from './IncompatibleScreen.vue';
import HiddenField from './HiddenField.vue';
import ThankYou from './ThankYou.vue';
import ProgressBar from './ProgressBar.vue';

const IPAD_MIN_WIDTH = 768;


export default /*#__PURE__*/_defineComponent({
  __name: 'FontApp',
  props: {
    apiUrl: {},
    creds: {},
    formId: {},
    fields: {},
    config: {}
  },
  setup(__props: any) {

const props = __props;



const currentIndex = ref(0);
const questionElement = ref();
const entryId = ref();

const previousPage = () => {
    currentIndex.value--;
};

const nextPage = () => {
    if (currentIndex.value > visibleFields.value.length + 1) {
        save();
    }
    currentIndex.value++;
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
};

const isIPadOrLarger = ref(window.screen.width >= IPAD_MIN_WIDTH);

const checkScreenSize = () => {
    isIPadOrLarger.value = window.screen.width >= IPAD_MIN_WIDTH;
};

const formFields = computed(() => {
    try {
        return JSON.parse(props.fields);
    } catch (e) {
        console.error(e);
        return [];
    }
});

const testConfig = computed(() => {
    try {
        return JSON.parse(props.config);
    } catch (e) {
        console.error(e);
        return [];
    }
});

const visibleFields = computed(() => {
    return formFields.value.filter((field) => !field.hidden);
});

const hiddenFields = computed(() => {
    return formFields.value.filter((field) => field.hidden && field.name !== 'conditions-other');
});

const conditionsOtherField = computed(() => {
    return formFields.value.find((field) => field.name === 'conditions-other');
});

onMounted(() => {
    window.addEventListener('resize', checkScreenSize);
});

onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize);
});

const getFieldValue = (field, value) => {
    if (field?.name === 'questions') {
        const responses = [];
        for (const element of questionElement.value) {
            responses.push(element.response);
        }
        return JSON.stringify(responses);
    }
    return value;
};

const form = ref();

const save = () => {
    const formData = new FormData(form.value);
    const formObject = {
        'form_id': props.formId,
    };
    formData.forEach((value, key) => {
        const fieldKey = key.replace('input_', '');
        const field = formFields.value.find((field) => +field.id === +fieldKey);
        formObject[fieldKey] = getFieldValue(field, value);
    });

    let url = props.apiUrl;
    let method = 'POST';
    if (entryId.value) {
        url = `${url}/${entryId.value}`;
        method = 'PUT';
    }

    fetch(url, {
        method,
        headers: {
            'Authorization': `Basic ${props.creds}`,
            'Content-Type': 'application/json'
        },
            body: JSON.stringify(formObject)
        })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
        }
        return response.json();
    })
    .then(data => {
        if (data?.id) {
            entryId.value = data.id;
        }
    })
    .catch(error => console.error('Error:', error));
}

const total = computed(() => {
    return visibleFields.value.length + testConfig.value.questions.length + 3;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isIPadOrLarger.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(IncompatibleScreen)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(ProgressBar, {
              total: total.value - 1,
              totalComplete: currentIndex.value
            }, null, 8, ["total", "totalComplete"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("form", {
                class: "max-w-7xl px-16 py-52",
                ref_key: "form",
                ref: form,
                onsubmit: "return false"
              }, [
                _withDirectives(_createVNode(FirstStep, { onNextPage: nextPage }, null, 512), [
                  [_vShow, currentIndex.value === 0]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleFields.value, (field, index) => {
                  return _withDirectives((_openBlock(), _createBlock(UserInputQuestion, {
                    key: `user-input-${index}`,
                    fieldIndex: index + 1,
                    currentIndex: currentIndex.value,
                    onPreviousPage: previousPage,
                    onNextPage: nextPage,
                    field: field
                  }, {
                    default: _withCtx(() => [
                      (field.name === 'conditions')
                        ? (_openBlock(), _createBlock(HiddenField, {
                            key: 0,
                            field: conditionsOtherField.value
                          }, null, 8, ["field"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["fieldIndex", "currentIndex", "field"])), [
                    [_vShow, currentIndex.value === 1 + index]
                  ])
                }), 128)),
                _withDirectives(_createVNode(QuestionsCover, {
                  onPreviousPage: previousPage,
                  onNextPage: nextPage
                }, null, 512), [
                  [_vShow, currentIndex.value === visibleFields.value.length + 1]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testConfig.value.questions, (question, index) => {
                  return _withDirectives((_openBlock(), _createBlock(Question, {
                    ref_for: true,
                    ref_key: "questionElement",
                    ref: questionElement,
                    key: `question-${index}`,
                    onPreviousPage: previousPage,
                    onNextPage: nextPage,
                    question: question,
                    "text-snippets": testConfig.value.textSnippets,
                    "is-last-question": index === testConfig.value.questions.length - 1
                  }, null, 8, ["question", "text-snippets", "is-last-question"])), [
                    [_vShow, currentIndex.value === visibleFields.value.length + 2 + index]
                  ])
                }), 128)),
                _withDirectives(_createVNode(ThankYou, {
                  onBack: _cache[0] || (_cache[0] = ($event: any) => (currentIndex.value = 0))
                }, null, 512), [
                  [_vShow, currentIndex.value === visibleFields.value.length + testConfig.value.questions.length + 2]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hiddenFields.value, (hiddenField, index) => {
                  return (_openBlock(), _createBlock(HiddenField, {
                    field: hiddenField,
                    key: `hidden-${index}`,
                    "is-test-complete": currentIndex.value + 1 === total.value - 1
                  }, null, 8, ["field", "is-test-complete"]))
                }), 128))
              ], 512)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createTextVNode("A project by"),
              _hoisted_7,
              _createTextVNode("American Printing House")
            ], 512), [
              [_vShow, currentIndex.value === 0 || currentIndex.value + 1 === total.value]
            ])
          ])
        ]))
  ]))
}
}

})